export const trustpilotConfig = {
  businessId: '5d949991dff97e00014e194b',
  locale: 'fi-FI',
  link: 'https://fi.trustpilot.com/review/axolaina.fi',
};
